import React from 'react'
import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import GoogleIcon from '../../../components/icon/GoogleIcon'

const actionButtonSx = {
  minWidth: 118,
  height: 34,
  borderRadius: '4px',
  px: 2,
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  boxShadow: 'none'
}

const getActionSx = (variant) => {
  if (variant === 'contained') {
    return {
      ...actionButtonSx,
      backgroundColor: '#ff893d',
      color: '#ffffff',
      border: '1px solid #ff893d',
      '&:hover': {
        backgroundColor: '#ff771f',
        borderColor: '#ff771f',
        boxShadow: 'none'
      },
      '&.Mui-disabled': {
        backgroundColor: '#d7d8db',
        borderColor: '#d7d8db',
        color: '#f8f8f8'
      }
    }
  }

  return {
    ...actionButtonSx,
    borderColor: '#d3d6dc',
    color: '#8a8f98',
    backgroundColor: '#ffffff',
    '&:hover': {
      borderColor: '#bcc3cd',
      backgroundColor: '#f8f9fb'
    }
  }
}

export default function SpecialFormHeaderActions({
  title,
  description,
  helperText,
  actions = [],
  children,
  showDivider = true
}) {
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          flexDirection: { xs: 'column', md: 'row' }
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          {title && (
            <Typography
              variant="h6"
              sx={{ mb: description || helperText || children ? 0.75 : 0, color: '#26345f' }}
            >
              {title}
            </Typography>
          )}

          {description && (
            <Typography sx={{ fontSize: '18px', lineHeight: 1.5 }}>
              {description}
            </Typography>
          )}

          {helperText && (
            <Typography sx={{ mt: 0.5, fontSize: '13px', color: '#8b92a0', lineHeight: 1.45 }}>
              {helperText}
            </Typography>
          )}

          {children}
        </Box>

        {actions.length > 0 && (
          <Stack direction="row" spacing={1.25} sx={{ flexShrink: 0 }}>
            {actions.map((action, index) => {
              const {
                key,
                label,
                type = 'button',
                variant = 'outlined',
                icon,
                iconPosition = 'start',
                iconProps = {},
                onClick,
                disabled = false,
                buttonProps = {},
                sx
              } = action

              const buttonIcon = icon ? <GoogleIcon name={icon} size={24} {...iconProps} /> : null

              return (
                <Button
                  key={key || `${label}-${index}`}
                  type={type}
                  variant={variant}
                  onClick={onClick}
                  disabled={disabled}
                  startIcon={iconPosition === 'start' ? buttonIcon : undefined}
                  endIcon={iconPosition === 'end' ? buttonIcon : undefined}
                  sx={{ ...getActionSx(variant), ...sx }}
                  {...buttonProps}
                >
                  {label}
                </Button>
              )
            })}
          </Stack>
        )}
      </Box>

      {showDivider && <Divider sx={{ mt: 2.25, borderColor: '#000000' }} />}
    </Box>
  )
}
